import { useCallback } from "react";

import { useIntl } from "react-intl";

import formatSeconds from "@app/scene/dashboard/utils/formatSeconds";

const useSecondsFormatter = () => {
  const intl = useIntl();
  return useCallback((value: number) => formatSeconds(intl, value), [intl]);
};

export default useSecondsFormatter;
